import { render } from "./ViewDetailDokumenPengadaan.vue?vue&type=template&id=733819a6"
import script from "./ViewDetailDokumenPengadaan.vue?vue&type=script&lang=js"
export * from "./ViewDetailDokumenPengadaan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__